var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgI3P(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "662px",
    height: "216px",
    viewBox: "0 0 662 216",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Untitled") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i3P_logo_senza_scritta_Politecnico",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.4,215.6 C107.9,215.6 95.4,161.1 95.4,137.7 L95.4,135.2 L176.9,135.2 C177.7,139.9 180.2,163.6 232.3,163.6 C284.4,163.6 288.8,151.6 288.8,143.6 C288.8,135.8 283.8,129.1 263.2,129.1 L193.9,129.1 L193.9,79.6 L261.2,79.6 C280.4,79.6 284.6,74 284.6,67.6 L284.6,67.3 C284.6,60.1 281,51.4 229.8,51.4 C178.6,51.4 178,69 177.5,73.2 L96.6,73.2 L96.6,70.4 C96.6,49.5 106.6,0.9 223.4,0.9 L235.4,0.9 C354.4,0.9 366.4,31.5 366.4,54.3 L366.4,56 C366.4,76.6 346.6,88.3 330,91.3 C350,95.8 374,109.4 374,141.9 L374,143.9 C374,178.1 352.3,215.7 239.9,215.7 L226.4,215.6 Z",
    id: "Path",
    fill: "#00359E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.8,4.8 L391.3,4.8 L391.3,5.5 L391.4,5.5 C422,21.8 473.6,16.7 493.4,14 C502.5,12.7 511.8,13.3 520.7,15.9 C542.3,22.4 549.2,37 555.8,45.2 C564.1,55.5 574.1,69.8 584.9,70.4 C595.7,71 599.2,61.3 599.2,61.3 C585.1,49.7 585.4,35.5 585.4,35.5 C585.4,35.5 616.9,70.7 622.6,74.9 C628.3,79.1 630.1,82.2 629,83.1 C627.9,84 628.7,88 617,86.4 C605.3,84.8 593,87.1 586.4,87.7 C576.8,88.6 563.1,93.8 557.6,103.3 C554.4,108.8 551.5,118.5 549.6,125.7 C548.1,131.4 543.9,136.1 538.4,138.2 C538.4,138.2 546.3,114.9 523.7,95.9 L471.2,146.9 L563.7,146.9 C639.4,146.9 661.9,115.2 661.9,77.6 L661.9,73.2 C662,35.1 640.3,4.8 563.8,4.8 Z",
    id: "Path",
    fill: "#00359E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.9,70.8 C442.8,52.1 414.9,40.7 391.3,31.6 L391.3,211.7 L470.3,211.7 L470.3,208.6 L438.2,140.1 C438.3,140.1 485.4,101.8 458.9,70.8 Z",
    id: "Path",
    fill: "#00359E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.5,138.2 C544,136.1 548.2,131.4 549.7,125.7 C551.6,118.5 554.5,108.8 557.7,103.3 C563.1,93.8 576.9,88.5 586.5,87.7 C593.1,87.1 605.3,84.8 617.1,86.4 C628.9,88 628.1,84 629.1,83.1 C630.1,82.2 628.3,79.1 622.7,74.9 C617.1,70.7 585.5,35.5 585.5,35.5 C585.5,35.5 585.2,49.7 599.3,61.3 C599.3,61.3 595.8,70.9 585,70.4 C574.2,69.9 564.2,55.5 555.9,45.2 C549.3,37 542.3,22.4 520.8,15.9 C512,13.3 502.7,12.7 493.5,14 C473.7,16.8 422.1,21.8 391.5,5.5 L391.4,5.5 L391.4,31.6 C415,40.6 442.9,52 459,70.8 C485.5,101.8 438.3,140.1 438.3,140.1 L470.4,208.6 L470.4,146.9 L471.3,146.9 L523.8,95.9 C546.4,114.8 538.5,138.2 538.5,138.2 Z",
    id: "Path",
    fill: "#25E5E0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#00359E",
    x: 0,
    y: 4.8,
    width: 78.7,
    height: 68.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#00359E",
    x: 0,
    y: 80.2,
    width: 78.7,
    height: 131.6
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgI3P);
export default __webpack_public_path__ + "static/media/i3p.5a21c14ade9faf9cedd1f0ebe0276f06.svg";
export { ForwardRef as ReactComponent };